<div [hidden]="loading()">
  <!-- Duplicate hydration rendering fix: https://github.com/angular/angular/issues/50543#issuecomment-1573339782 -->
  <ng-content /><ng-container
    [ngTemplateOutlet]="results()"
    [ngTemplateOutletContext]="{ rows }"
  >
  </ng-container>
</div>

@if (rows().length === 0 && !loading()) {
  <div class="mobi-ui-margin-t-md mobi-ui-margin-b-md">
    <div class="mobi-ui-card-silent mobi-ui-ink-blue">
      <div class="mobi-ui-text-block-major">
        <mobi-ui-icon-major name="info" />
        <div class="mobi-ui-text-block-content-major">
          <span class="mobi-ui-text-block-title-major">
            {{
              'no_results_title'
                | texts
                  : {
                      context: 'frontend',
                      default: 'Es wurden keine Resultate für Ihre Eingabe gefunden.',
                    }
            }}
          </span>
          {{
            'no_results_text'
              | texts
                : {
                    context: 'frontend',
                    default:
                      'Passen bitte Sie die Filterkriterien an und versuchen sie es erneut.',
                  }
          }}
        </div>
      </div>
    </div>
  </div>
}
@if (loading() || loadingMore()) {
  <mobi-ui-loading-indicator-major></mobi-ui-loading-indicator-major>
}

@if (hasPagination() && !loading() && !loadingMore()) {
  <div class="flex justify-center">
    <button
      class="mobi-ui-btn-minor mobi-ui-ink-default mobi-ui-margin-t-lg"
      (click)="loadNext.emit()"
    >
      {{ 'show_more' | texts: { context: 'frontend', default: 'Mehr anzeigen' } }}
    </button>
  </div>
}
